<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <form autocomplete="off" method="post" @submit.prevent="addExpense">
      <div class="row">
        <div
          class="imgView"
          :style="{ 'background-image': `url(${imageSrc})` }"
          :onerror="`this.src='${defaultImg}'`"
          alt="Image"
          @click="selectImage"
        ></div>
        <!-- @input="pickFile" -->
        <input
          ref="fileInput"
          type="file"
          v-on:change="pickFile"
          class="d-none"
          accept=".jpg, .jpeg, .png"
        />
      </div>
      <div class="my-card">
        <div class="row">
          <CustomInput
            :className="'col-md-6 col-lg-6'"
            :id="'establishmentExpensesCode'"
            :value="expenseData.establishmentExpensesCode"
            :title="$t('expenseCode')"
            :imgName="'number.svg'"
            v-on:changeValue="expenseData.establishmentExpensesCode = $event"
          />
          <CustomSelectBox
            :className="'form-label-group  col-6'"
            :id="'establishmentExpensesTypeToken'"
            :value="expenseData.establishmentExpensesTypeToken"
            :options="expensesTypeTokenOptions"
            v-on:changeValue="
              expenseData.establishmentExpensesTypeToken = $event
            "
            :title="$t('selectExpenseType')"
            :imgName="'expenses-types.svg'"
          />
          <CustomSelectBox
            :className="'form-label-group  col-6'"
            :id="'establishmentTreasuryToken'"
            :value="expenseData.establishmentTreasuryToken"
            :options="treasuryTokenOptions"
            v-on:changeValue="expenseData.establishmentTreasuryToken = $event"
            :title="$t('selectExpenseType')"
            :imgName="'treasuries.svg'"
          />

          <DatePicker
            :className="'col-md-6'"
            :id="'establishmentExpensesDatePayed'"
            :value="expenseData.establishmentExpensesDatePayed"
            :title="$t('date')"
            :language="language"
            v-on:changeValue="
              expenseData.establishmentExpensesDatePayed = $event
            "
          />

          <CustomInput
            :className="'col-md-6'"
            :id="'establishmentExpensesMoneyValue'"
            :value="expenseData.establishmentExpensesMoneyValue"
            :title="$t('money')"
            :imgName="'money.svg'"
            v-on:changeValue="
              expenseData.establishmentExpensesMoneyValue = $event
            "
          />
          <TextArea
            :className="'col-md-6'"
            :id="'establishmentExpensesNotes'"
            :value="expenseData.establishmentExpensesNotes"
            :title="$t('notes')"
            :imgName="'notes.svg'"
            v-on:changeValue="expenseData.establishmentExpensesNotes = $event"
          />
        </div>
      </div>

      <div class="form-footer">
        <button name="submit" type="submit" class="btn btn-submit">
          {{ submitName }}
        </button>
        <router-link :to="{ name: 'Expenses' }" class="btn btn-cancel">
          {{ $t("cancel") }}
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import DEFAULT_IMG_EXPENSE from "@/assets/images/expenses.svg";
import axios from "axios";
import DatePicker from "@/components/general/DatePicker.vue";
import CustomInput from "@/components/general/CustomInput.vue";
import TextArea from "@/components/general/TextArea.vue";
import Treasury from "@/models/finance/treasuries/Treasury";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";

export default {
  name: "ExpenseForm",
  components: {
    PreLoader,
    ExceptionWithImg,
    DatePicker,
    CustomInput,
    TextArea,
    CustomSelectBox,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      treasuryData: new Treasury(),
      defaultImg: DEFAULT_IMG_EXPENSE,
      expensesTypeTokenOptions: [],
      treasuryTokenOptions: [],
    };
  },
  props: ["expenseData", "imageSrc", "submitName"],
  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrc = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
        this.expenseData.image = file[0];
      } else {
        this.imageSrc = DEFAULT_IMG_EXPENSE;
        this.expenseData.image = "";
      }
    },
    async getDialogOfExpensesTypes() {
      this.isLoading = true;
      this.expensesTypeTokenOptions = [];
      this.expensesTypeTokenOptions.push({
        value: "",
        text: this.$t("selectExpenseType"),
      });
      try {
        const response = await axios.get(
          `/ExpensesTypes/GetDialogOfExpensesTypes?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}`
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.expensesTypeTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfTreasuries() {
      this.isLoading = true;
      this.treasuryTokenOptions = [];
      this.treasuryTokenOptions.push({
        value: "",
        text: this.$t("selectTreasury"),
      });
      try {
        const response = await this.treasuryData.getDialogOfTreasuries(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.treasuryTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },

    async addExpense() {
      this.$emit("addExpense");
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      if (lang == "en") return dataEn;
      else return dataAr;
    },
  },
  watch: {},
  async created() {
    this.getDialogOfExpensesTypes();
    this.getDialogOfTreasuries();
  },
};
</script>

<style lang="scss"></style>
